module.exports = __webpack_public_path__ + "media/images/fonts/lg-0392227eb4b4510402ab45dee2ceda73.woff";